var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VCheckbox',_vm._g(_vm._b({class:_vm.classList,scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label")]},proxy:true}],null,true)},'VCheckbox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }